import { ManagerBase } from '@core/ManagerBase';
import type { IAudioManager } from '@core/interfaces';

/** Ses yönetimi — Phase 2+ implementasyon */
export class AudioManager extends ManagerBase implements IAudioManager {
  protected onInitialize(): void {
    // Phase 2
  }

  protected onShutdown(): void {
    // Phase 2
  }
}
